import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API } from '@/service'
const api = {
  infoUrl: PREFIX_SCC_API + 'fchild/applyJoin/queryApplyResult.do',
  applyInfoUrl: PREFIX_SCC_API + 'fchild/applyJoin/applyJoin.do',
  applyInfoOwnUrl: PREFIX_SCC_API + 'fchild/applyJoin/applyJoinOwn.do',
  // applyPicUrl: '//sccapi.cekid.com/subscriber-web/crafts/applyPic.do',
  rewardUrl: `${utils.hostname(
    'subscriber'
  )}/subscriber-web/crafts/getRebateInfo.do`,
  credentialListUrl:
    PREFIX_SCC_API + 'fchild/applyJoin/queryNeedCredentials.do',
  cms4Choose: `${utils.hostname('cms')}/publish/999/chooseEnter.json`
}
export default {
  async getEnterInfo({ commit, state }, { uid, skey, tkey, managerUid }) {
    try {
      const query_param = {
        uid,
        tkey,
        skey,
        managerUid
      }
      const query = queryString.stringify(query_param)
      const infoData = await fetch(`${api.infoUrl}?${query}`, {
        credentials: 'include'
      })
      const infoJson = await infoData.json()
      let info = {}
      if (infoJson.code === '1') {
        info = infoJson.data || {}
        commit('setEnterInfo', info)
      }
      return infoJson
    } catch (e) {
      throw new Error(e.message)
    }
  },
  async saveBasicInfo({ commit }, { info }) {
    try {
      const param = info
      const info_res = await fetch(api.applyInfoUrl, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        body: `param=${encodeURIComponent(JSON.stringify(param))}`,
        credentials: 'include'
      })
      const infoJSON = await info_res.json()
      return infoJSON
    } catch (e) {
      console.log(e)
    }
  },
  async saveBasicInfoOwn({ commit }, { info }) {
    try {
      const param = info
      const info_res = await fetch(api.applyInfoOwnUrl, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        body: `param=${encodeURIComponent(JSON.stringify(param))}`,
        credentials: 'include'
      })
      const infoJSON = await info_res.json()
      return infoJSON
    } catch (e) {
      console.log(e)
    }
  },
  // async savePicsInfo({ commit }, { info }) {
  //     try {
  //         const param = info
  //         const info_res = await fetch(api.applyPicUrl, {
  //             headers: {
  //                 'Content-Type': 'application/json'
  //             },
  //             method: 'POST',
  //             body: JSON.stringify(param),
  //             credentials: 'include'
  //         })
  //         const infoJSON = await info_res.json()
  //         return infoJSON
  //     } catch (e) {
  //         console.log(e);
  //     }
  // },

  async getCredentialsByCate({ commit, state }, { categoryIds }) {
    try {
      const query_param = {
        categoryIds
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.credentialListUrl}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      let credentialList = []
      if (json.code === '1') {
        credentialList = json.data || []
        commit('setCredentialList', credentialList)
      } else {
        throw new Error(json.code)
      }
      return credentialList
    } catch (e) {
      throw new Error(e.message)
    }
  },
  async getRewards({ commit }, { uid, type, pageNo, pageSize }) {
    try {
      const query_param = {
        uid,
        type,
        pageNo,
        pageSize
      }
      const query = queryString.stringify(query_param)
      const reward_res = await fetch(`${api.rewardUrl}?${query}`, {
        credentials: 'include'
      })
      const rewardJson = await reward_res.json()
      if (rewardJson.code === '0' && rewardJson.content.result) {
        if (pageNo === 1) {
          commit('resetRewards')
        }
        if (type === 1) {
          commit('setRewards', rewardJson.content.result.joinInfos)
        } else {
          commit('setRewards', rewardJson.content.result.certifacateInfos)
        }
      }
      return rewardJson
    } catch (e) {
      console.log(e)
    }
  },
  async getCmsConfig4Choose({ commit, state }) {
    try {
      const data_res = await fetch(`${api.cms4Choose}`)
      const dataJson = await data_res.json()
      return dataJson
    } catch (e) {
      throw new Error(e)
    }
  }
}
